import { combineReducers, createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { reducer as formReducer } from "redux-form";

import auth from "./auth";
import shops from "./shops";
import workingHours from "./workingHours";
import clientTable from "./clientTable";

let reducer = combineReducers({
	form: formReducer,
	auth,
	shops,
	workingHours,
	clientTable,
});

const store = createStore(
	reducer,
	composeWithDevTools(applyMiddleware(thunkMiddleware))
);

export default store;
